import moment from 'moment';
import { OverAllocationApi } from 'api/resource-management/types';
import { OverAllocationForUi } from '../event-types';

export const overAllocationsAsUIFormat = (
  overAllocations: OverAllocationApi[],
): OverAllocationForUi[] =>
  overAllocations?.map(({ startDate, endDate, overAllocatedMinutes }) => ({
    overAllocatedMinutes,
    startDate: moment(startDate).startOf('day').toDate(), // check for an alternative of moment
    endDate: moment(endDate).endOf('day').toDate(),
  }));
